<template>
  <v-dialog
    v-model="visible"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-app-bar dark color="primary">
      <v-btn icon dark @click="onClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Bild {{ id }}</v-toolbar-title>
    </v-app-bar>
    .
    <div class="image-preview-container">
      <div v-for="img in sizes" :key="img.size" class="preview-image">
        <div class="preview-image-size">{{ `${img.width}x${img.height}` }}</div>
        <img :src="img.src" alt="" />
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'ImageViewer',
  components: {},
  data() {
    return {
      visible: false,
      id: null,

      sizes: [
        {
          size: 1920,
          exists: false,
          width: 0,
          height: 0,
          src: null,
        },
        {
          size: 1170,
          exists: false,
          width: 0,
          height: 0,
          src: null,
        },
        {
          size: 870,
          exists: false,
          width: 0,
          height: 0,
          src: null,
        },
        {
          size: 570,
          exists: false,
          width: 0,
          height: 0,
          src: null,
        },
        {
          size: 270,
          exists: false,
          width: 0,
          height: 0,
          src: null,
        },
        {
          size: 220,
          exists: false,
          width: 0,
          height: 0,
          src: null,
        },

        {
          size: 170,
          exists: false,
          width: 0,
          height: 0,
          src: null,
        },
      ],
      isInitialized: false,
    }
  },
  watch: {
    $route: {
      handler: function ({ hash }) {
        if (hash.startsWith('#image:')) {
          const id = hash.split(':').pop()
          this.id = id
          this.visible = true
          this.checkFileExist()
          return
        }
        this.visible = false
      },
      immediate: true,
    },
  },
  computed: {},
  methods: {
    onClose() {
      this.id = null
      this.$router.replace({ ...this.$route, hash: `` })
    },
    checkFileExist() {
      this.sizes.forEach(({ size }, i) => {
        const url = `${process.env.VUE_APP_IMAGE_BACKEND}/${size}/${this.id}.jpg`
        const img = new Image()
        img.src = url
        img.onload = () => {
          this.sizes[i].exists = true
          this.sizes[i].width = img.width
          this.sizes[i].height = img.height
          this.sizes[i].src = img.src
        }
        img.onerror = () => {
          this.sizes[i].exists = false
        }
      })
      this.isInitialized = true
    },
  },
  // created() {
  //   this.checkFileExist()
  // },
}
</script>

<style lang="less" scoped>
.image-preview-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 20px;
  background: #fff;
  padding: 20px;
  margin-top: -25px;

  .preview-image {
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    .preview-image-size {
      font-size: 34px;
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(50%, -50%);
      color: #fff;
      opacity: 0.5;
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
